import React from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { AttachDocsContent } from './components';

export const AttachDocumentsPage = () => {
  const navigation = useNavigate();
  const location = useLocation();
  const props = location.state as any;

  return (
    <div className="h-full w-full min-h-screen flex flex-col">
      <AttachDocsContent {...props} onClose={() => navigation(-1)} />
    </div>
  );
};
